<section class="ava-header">
    <div class="searchbar">
        <mis-input type="rounded" placeholder="Search">
            <span mis-input-icon><img src="/assets/images/search.svg" alt="search" /></span>
            <input type="text" [(ngModel)]="searchInput" (ngModelChange)="onSearchInputChange($event)" misInput
                placeholder="Start typing..." />
        </mis-input>

    </div>
    <div class="cityFilter">
        <mis-dropdown [data]="cities" [searchEnabled]="true" [label]="firstCity" height="38px" width="250px"
            dropdownListHeight="232px" dropdownListWidth="250px" dropdownListPosition="Left" noDataMessage="No Data"
            (onChange)="selectVendorCity($event)">
        </mis-dropdown>
    </div>
    <div class="bookingTypeFilter">
        <mis-dropdown [data]="bookingType" [searchEnabled]="true" [label]="firstBookingType" height="38px" width="250px"
            dropdownListHeight="232px" dropdownListWidth="250px" dropdownListPosition="Left" noDataMessage="No Data"
            (onChange)="selectBookingType($event)">
        </mis-dropdown>
    </div>

    <div class="ava-btns-container displayFlexSpaceBetween align-item-center">
        <button class="ava-btn displayFlexSpaceBetween align-item-center" (click)="uploadAVAConfiguration()">
            <span class="ava-btn-icon displayFlexCenter align-item-center"><img src="/assets/images/upload-file.svg" alt="" /></span>
            Upload Template
        </button>
        <button class="ava-btn displayFlexSpaceBetween align-item-center" (click)="downloadAVAConfiguration()">
            <span class="ava-btn-icon displayFlexCenter align-item-center"><img src="/assets/images/download-file.svg" alt="" /></span>
            Download Configuration
        </button>
    </div>
</section>

<section class="ava-page">
    <div class="ava-table">
        <span class="information fs-12"> <img class="infoIcon" src="assets/ic-action-info-24.svg" alt="information"> Total allotment percentage should be 100%</span>
        <table>
            <thead>
                <tr>
                    <th>Vendor</th>
                    <th>Allotment Percentage <span (click)="sortData()"><img src="assets/ic-action-sort2-24.svg" alt="sort"></span> </th>

                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of filtererdVendorList" [ngClass]="item.allocationPercentage=='0'? 'greyRow row':'row'">
                    <td>{{item.vendorName | titlecase}}</td>
                    <td>
                        <div class="inputPercentage">
                            <span>
                                <input type="number" [value]=item.allocationPercentage
                                (focusout)="percentChange(item,input.value)" #input>
                            </span>
                            <span>%</span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="timeout displayFlex">
        <span class="fs-12 mr-12">Acceptance Time</span>
        <mis-dropdown [data]="timeout" [searchEnabled]="false" [label]='timeoutTime' height="38px" width="250px"
            dropdownListHeight="232px" dropdownListWidth="250px" dropdownListPosition="Left" noDataMessage="No Data"
            (onChange)="selectTimeout($event)">
        </mis-dropdown>
    </div>

    <ng-template [ngIf]="showTimeoutError || showPercentageError || configApproval || successToast">
        <div [ngClass]="configApproval? 'ava-citySnackbar ava-snackbar ': 'ava-snackbar'">
            <span><img [src]=" successToast ? 'assets/successWhite.svg' : 'assets/ic-ui-error-24.svg'"
                    alt="error"></span>
            {{toastMsg}}
        </div>
    </ng-template>
</section>

<div class="ava-foot">
    <span (click)="setInitialConditions()">Reset</span>
    <span (click)="onSave()">Save</span>
</div>

<app-dialog
  *ngIf="showSaveConfigWarning"
  titleText="Warning"
  type="confirm"
  [buttonText]="['Save', 'Discard']"
  (approveCallback)="makeButtonSubmitEnable()"
  (dismissCallback)="setInitialConditions()"
  (closeCallback)="showSaveConfigWarning=false"
  [icon]="false"
  src="assets/ic-ui-warning-24.svg"
>
You have made changes for {{selectedCity}}. 
<div class="space"></div>
Do you want to save or discard them before you proceed?
</app-dialog>

<app-popover *ngIf="approverPopup" size="Approver-model" (closeCallback)="approverPopup=false">
    <div popover-header class="popover-header">Choose Approving Manager</div>

    <div popover-content class="search-approver-container">
        <div class="approver">
            <mis-input type="rounded" placeholder="Search">
                <span class="search-icon mr-16" mis-input-icon><img src="/assets/images/search.svg" alt="search" /></span>
                <input type="text" [(ngModel)]="approverSearch"
                 (ngModelChange)="onSearchApproverChange($event)" misInput
                    placeholder="Start typing..." />
            </mis-input>
            <div *ngIf="showMandatoryApprover" class="mandatoryError">
                * This field is mandatory
            </div>
           
        </div>


        <div class="approvertext">All configuration change requests need to be approved by a manager.
            Please use the field above to select or change approving manager.</div>

            <ng-template [ngIf]="showApproverList">
                <ul class="approverList">
                    <li  *ngFor="let approver of filteredApproverList" (click)="selectedApprover(approver)">{{approver.name}}</li>
                </ul>
            </ng-template>
    </div>


    <div popover-actions class="submit-button">
        <app-button type="plainText" text="Clear" class="mr-20" (clickCallback)="clearUpdate()"></app-button>
        <app-button type="primaryFilled" text="Submit" (clickCallback)="submitVendorConfigUpdate()"></app-button>
    </div>

</app-popover>